import React, { useState, useEffect } from "react";
import "../Testimonials/Testimonials.css";

const testimonialsData = [
  {
    name: "Aarav Sharma",
    role: "Traveler",
    image: "/user.webp",
    rating: 4,
    text: "The trip was well-organized and the destinations were breathtaking. A memorable experience with great hospitality and guides!",
  },
  {
    name: "Meera Iyer",
    role: "Tourist",
    image: "/user3.avif",
    rating: 5,
    text: "From booking to the final day, everything was smooth. The cultural experiences and local food recommendations were top-notch!",
  },
  {
    name: "Raj Patel",
    role: "Explorer",
    image: "/user2.webp",
    rating: 3,
    text: "The overall tour was good, though the travel time between locations was a bit long. Still, the views made it worth it.",
  },
];

const Testimonials = () => {
  const [index, setIndex] = useState(0);

  const prev = () => {
    setIndex(
      (prevIndex) =>
        (prevIndex - 1 + testimonialsData.length) % testimonialsData.length,
    );
  };

  const next = () => {
    setIndex((prevIndex) => (prevIndex + 1) % testimonialsData.length);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      next();
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const getVisibleCards = () => {
    const total = testimonialsData.length;
    const left = (index - 1 + total) % total;
    const center = index;
    const right = (index + 1) % total;
    return [left, center, right].map((i) => testimonialsData[i]);
  };

  const visibleCards = getVisibleCards();

  return (
    <section className="testimonial-section">
      <div className="testimonial-header">
        <span className="label">TESTIMONIAL</span>
        <h2>See what they are talking about?</h2>
      </div>
      <div className="testimonial-slider">
        <button onClick={prev} className="arrow left">
          ←
        </button>
        <div className="testimonial-carousel">
          <div className="testimonial-track">
            {visibleCards.map((item, i) => {
              const position = i === 0 ? "left" : i === 1 ? "active" : "right";
              return (
                <div key={item.name} className={`testimonial-card ${position}`}>
                  <div className="testimonial-top">
                    <div className="image-wrapperr">
                      <img src={item.image} alt={item.name} />
                    </div>
                    <div className="user-info">
                      <div className="stars">
                        {"★".repeat(item.rating)}
                        {"☆".repeat(5 - item.rating)}
                      </div>
                      <h4>{item.name}</h4>
                      <p>{item.role}</p>
                    </div>
                  </div>
                  <p className="testimonial-text">{item.text}</p>
                  <div className="quote">“”</div>
                </div>
              );
            })}
          </div>
        </div>
        <button onClick={next} className="arrow right">
          →
        </button>
      </div>
    </section>
  );
};

export default Testimonials;
